import { ConfirmationOptions } from 'src/app/shared/secured-shared/confirmation-dialog/confirmation-dialog.models';
import { ChannelsService } from 'src/app/core/services/channels.service';

/** Deletes a station (from the list or from its edit dialog); the dialog runs the delete. */
export function deleteStationConfirmation(channelsService: ChannelsService, channelId: string): ConfirmationOptions {
  return {
    title: 'Delete Station',
    message: 'Are you sure you want to delete this station?',
    confirmLabel: 'Delete',
    destructive: true,
    action: () => channelsService.deleteChannel(channelId),
    testIds: {
      message: 'channel-dialog-delete-message',
      cancel: 'channel-dialog-cancel-button',
      confirm: 'channel-dialog-delete-button',
    },
  };
}
